import React from 'react'
import Navbar from './components/NavBar/Navbar'
import College from './components/College/College'
import Programs from './components/Programs/Programs'
import Main from './components/Main/Main'
import About from './components/About/About'
import Tastimonials from './components/Tastimonials/Tastimonials'
import Contact from './components/Contact/Contact'
import Footer from './components/Footer/Footer'

const App = () => {
  return (
    <div>
    <Navbar/>
      <College/>
      
      
      <div className="container">
        <Main subTitle='all programs' title='fuel your ambition'/>
         <Programs/>
         <About/>
         <Main subTitle='TESTIMONIALS' title='Hear From Our Students'/>
         <Tastimonials/>
          <Main subTitle='Contact Us' title='Reach Out'/>
          <Contact />
          <Footer/>
          </div>
      </div>  
    
  )
}

export default App
